module.exports = __webpack_public_path__ + "static/media/nus-logo-white.bc9a6e7d.png";